import { FC } from "react";
import classNames from "classnames";

type Props = {
  label: string;
  value: string | number;
  hint?: string;
  className?: string;
};

export const EvoStatTile: FC<Props> = ({ label, value, hint, className }) => {
  return (
    <div
      className={classNames(
        "rounded-xl border border-evo-border bg-evo-surface px-4 py-3 shadow-[var(--evo-shadow-sm)]",
        className
      )}
    >
      <p className="text-[11px] font-medium uppercase tracking-wider text-evo-muted">{label}</p>
      <p className="mt-1 text-2xl font-semibold tabular-nums tracking-tight text-evo-text">{value}</p>
      {hint ? <p className="mt-1 text-xs text-evo-subtle">{hint}</p> : null}
    </div>
  );
};
